import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=df270ef8&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"
import style0 from "./Empty.vue?vue&type=style&index=0&id=df270ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df270ef8",
  null
  
)

export default component.exports